import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, switchMap, catchError, throwError } from 'rxjs';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {
  private authenticationService = inject(AuthenticationService);

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    return this.authenticationService.getToken().pipe(
      switchMap((token) => {

        if (token) {

          const authorizationValue = request.url.startsWith(environment.backendUrl)
            ? `Bearer ${token}`
            : token;

          request = request.clone({
            setHeaders: {
              Authorization: authorizationValue
            }
          });
        }

        return next.handle(request).pipe(
          catchError((error: HttpErrorResponse) => {

            if (error.status === 401) {
              return this.authenticationService.getToken().pipe(
                switchMap((newToken) => {

                  if (!newToken) {
                    return throwError(
                      () => new Error(`Error to call ${request.url}: no token`)
                    );
                  }

                  const authorizationValue = request.url.startsWith(environment.backendUrl)
                    ? `Bearer ${newToken}`
                    : newToken;

                  const retryRequest = request.clone({
                    setHeaders: {
                      Authorization: authorizationValue
                    }
                  });

                  return next.handle(retryRequest);
                })
              );
            }

            if (error.error?.internalStatusCode === '802') {
              return next.handle(request);
            }

            return throwError(
              () =>
                new Error(
                  `Error to call ${request.url}: ${
                    error.error?.internalStatusCode ?? error.message
                  }`
                )
            );
          })
        );
      })
    );
  }
}